// extracted by mini-css-extract-plugin
module.exports = {"comment-msg__msg-video":"RenderLoomVideo_comment-msg__msg-video__7LjYM"};